"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvirioWindowMarkerClusterer = void 0;
var React = require("react");
var react_google_maps_1 = require("@120wateraudit/react-google-maps");
var EnvirioMarker_1 = require("./EnvirioMarker");
var EnvirioMapStyles_1 = require("./EnvirioMapStyles");
var EnvirioWindowMarkerClusterer = /** @class */ (function (_super) {
    __extends(EnvirioWindowMarkerClusterer, _super);
    function EnvirioWindowMarkerClusterer(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggleOpen = function (key) { return function () {
            _this.setState({
                activeWindowKey: key
            });
        }; };
        _this.state = {
            activeWindowKey: undefined
        };
        return _this;
    }
    EnvirioWindowMarkerClusterer.prototype.render = function () {
        var _this = this;
        var _a = this.props, markers = _a.markers, keyExtension = _a.keyExtension, bounds = _a.bounds, renderInfoWindow = _a.renderInfoWindow;
        var activeWindowKey = this.state.activeWindowKey;
        return (React.createElement(react_google_maps_1.MarkerClusterer, { averageCenter: true, enableRetinaIcons: true, gridSize: 60, styles: EnvirioMapStyles_1.clusterIconStyles, defaultTitle: 'Click to see more locations.', title: "Click to see all locations" }, markers.map(function (marker, i) {
            var key = marker.position.lat + "-" + marker.position.lng + i + (keyExtension || '');
            bounds.extend(marker.position);
            var icon = EnvirioMarker_1.getPinColorForMap(marker.color);
            if (!marker.info) {
                marker.info = {};
            }
            return (React.createElement(react_google_maps_1.OverlayView, { key: key, position: marker.position, mapPaneName: react_google_maps_1.OverlayView.OVERLAY_MOUSE_TARGET },
                React.createElement(react_google_maps_1.Marker, { key: key, position: marker.position, clickable: true, icon: icon, onClick: _this.onToggleOpen(key) }, activeWindowKey && activeWindowKey === key &&
                    React.createElement(react_google_maps_1.InfoWindow, { onCloseClick: _this.onToggleOpen() },
                        React.createElement(React.Fragment, null, renderInfoWindow && renderInfoWindow(marker.info))))));
        })));
    };
    return EnvirioWindowMarkerClusterer;
}(React.Component));
exports.EnvirioWindowMarkerClusterer = EnvirioWindowMarkerClusterer;
//# sourceMappingURL=EnvirioWindowMarkerClusterer.js.map